import { Badge } from '@ps/isp-web-component-library';
import { Rab } from '@ps/isp-web-component-library/icons/Rab';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { Selection } from '@swf/sports/components';

import type { MarketDynamicBanner } from '../../../../model/types';
import EventStatus from '../components/EventStatus';

import { TXTWCL_Request_A_Bet, TXTWCL_request_a_bet_selection } from './RequestABet.messages.json';
import styles from './RequestABet.scss';

const RequestABetDynamicBanner: React.FC<MarketDynamicBanner> = ({
  event,
  market,
  eventType,
  competition
}) => {
  const { formatMessage } = useRegulatoryIntl();
  const [runner] = market.runners;

  return (
    <>
      <div className={styles.eventStatusContainer}>
        <EventStatus
          badge={
            <Badge
              icon={Rab}
              iconLabel={formatMessage(TXTWCL_request_a_bet_selection)}
              text={formatMessage(TXTWCL_Request_A_Bet)}
              size="base"
            />
          }
          startTime={event.eventStartTime}
          isTurnInPlay={market.turnInPlayEnabled}
          isInPlay={market.inPlay}
        />
      </div>
      <div className={styles.marketContainer}>
        <div className={styles.marketName}>{runner.runnerName}</div>
        <Selection
          competitionId={competition.competitionId}
          eventId={event.eventId}
          eventTypeId={eventType.eventTypeId}
          handicap={runner.handicap}
          key={runner.selectionId}
          legTypes={market.legTypes}
          marketId={market.marketId}
          marketStatus={market.marketStatus}
          odds={runner.winRunnerOdds}
          runnerResultType={runner.resultType}
          runnerStatus={runner.runnerStatus}
          selectionId={runner.selectionId}
          startTime={event.eventStartTime}
        />
      </div>
    </>
  );
};

export default RequestABetDynamicBanner;
